module.exports = require("pascal-case");